import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb29fae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "evaluation_content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head_content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "我的评测报告")
], -1))
const _hoisted_3 = { class: "evaluation-list-bg" }
const _hoisted_4 = {
  key: 0,
  class: "empty-card"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "empty-card-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, "暂无内容")
], -1))
const _hoisted_6 = {
  key: 1,
  class: "evaluation-list"
}
const _hoisted_7 = { class: "evaluation_item" }
const _hoisted_8 = { class: "evaluation_info" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space_line" }, null, -1))
const _hoisted_11 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_van_image, {
      class: "back_action",
      src: require('../assets/image/white_btn_icon.svg'),
      onClick: _ctx.close
    }, null, 8, ["src", "onClick"]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.list.length == 0 && !_ctx.listLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_van_image, {
              src: require('../assets/image/icon-empty-dark.png')
            }, null, 8, ["src"]),
            _hoisted_5
          ]))
        : _createCommentVNode("", true),
      (_ctx.list.length != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_van_pull_refresh, {
              class: "list-pull-refresh-view",
              modelValue: _ctx.lisrefreshing,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lisrefreshing) = $event)),
              onRefresh: _ctx.listOnRefresh
            }, {
              default: _withCtx(() => [
                _createVNode(_component_van_list, {
                  "loading-text": "加载中...",
                  loading: _ctx.listLoading,
                  "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listLoading) = $event)),
                  finished: _ctx.listFinished,
                  onLoad: _ctx.listOnLoad,
                  "finished-text": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                      return (_openBlock(), _createBlock(_component_van_cell, {
                        onClick: ($event: any) => (_ctx.evaluationItemClick(item))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_van_image, {
                              src: require('../assets/image/evaluation_detail_icon.svg')
                            }, null, 8, ["src"]),
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, _toDisplayString(item.title), 1),
                              _hoisted_10,
                              _createElementVNode("span", _hoisted_11, _toDisplayString(item.createDate), 1)
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["loading", "finished", "onLoad"])
              ]),
              _: 1
            }, 8, ["modelValue", "onRefresh"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode(_component_Loading, null, null, 512), [
      [_vShow, _ctx.listLoading]
    ])
  ]))
}